import {
  getFirestore,
  doc,
  setDoc,
  serverTimestamp,
  updateDoc,
  deleteDoc,
} from 'firebase/firestore';
import { app } from '../resources/gcp-config';
import { successAlert, errorAlert } from '../components/alerts';
import { v4 as uuidv4 } from 'uuid';

const db = getFirestore(app);

const createpos = async (formData) => {
  const posId = uuidv4();
  formData.updatedAt = serverTimestamp();
  formData.posId = posId;
  const documentId = formData?.document;
console.log(formData);
  try {
    // Create a new PO in the "pos" collection
    await setDoc(doc(db, 'pos', posId), formData);
    // Update the "classify" field in the "email-records" collection
    if (documentId) {
      await updateDoc(doc(db, 'email-records', documentId), {
        classify: 'PO',
      });
    }
    console.log('PO created successfully.', );
    successAlert(
      'Success!',
      'A new PO has been created, and email record updated.'
    );
  } catch (error) {
    console.error('Error creating PO or updating email record:', error);
    errorAlert('Error!', 'An error occurred while processing the request.');
  }
};

const updatepos = async (posId, formData) => {
  try {
    await updateDoc(doc(db, 'pos', posId), {
      ...formData,
      updatedAt: serverTimestamp(),
    });
    // successAlert('Success!', 'The pos has been updated.');
  } catch (error) {
    console.error('Error updating pos:', error);
    errorAlert('Error!', 'An error occurred while updating the Pos');
  }
};

const deletePOS = async (posId) => {
  try {
    await deleteDoc(doc(db, 'pos', posId));
    successAlert('Success!', 'The pos has been deleted.');
  } catch (error) {
    console.error('Error deleting pos:', error);
    errorAlert('Error!', 'An error occurred while deleting the Pos');
  }
};

const updateposArray = async (arrayElement, jsonObject, posId) => {
  // console.log(arrayElement, jsonObject, posId);
  try {
    const posRef = doc(db, 'pos', posId);
    await updateDoc(posRef, {
      [arrayElement]: jsonObject,
    });

    // console.log('pos array updated successfully.');
  } catch (error) {
    console.error('Error updating pos array:', error);
  }
};

export { createpos, updatepos, updateposArray, deletePOS };
